module.exports = __webpack_public_path__ + "static/media/bg-pic-running.7dc3a0dd.jpg";